import { scopes } from "./scopes";
import type { TScope, TScopes } from "./scopes";

function keyedBuilder<Key extends keyof TScopes, Actions extends TScopes[Key][number], >(key: Key, ...actions: Actions[]): `${Key}:${Actions}`[]; // prettier-ignore
function keyedBuilder<Key extends keyof TScopes>(key: Key): `${Key}:${TScopes[Key][number]}`[]; // prettier-ignore
function keyedBuilder<Key extends keyof TScopes>(
  key: Key,
  ...actions: TScopes[Key][number][]
) {
  if (actions.length > 0) return actions.map((action) => `${key}:${action}`);
  return scopes[key].map((action) => `${key}:${action}`);
}

type ScopeHelper = {
  [K in keyof TScopes]: <Verbs extends TScopes[K][number]>(
    ...verbs: Verbs[]
  ) => ReturnType<typeof keyedBuilder<K, Verbs>>;
};

function buildScopeHelper(scope: TScopes): ScopeHelper {
  const obj = {} as ScopeHelper;
  for (const key in scope) {
    obj[key] = (...verbs) => keyedBuilder(key as keyof TScopes, ...verbs);
  }
  return obj;
}

export const scopeBuilder = buildScopeHelper(scopes);

// Type checks
const _p = scopeBuilder.address("index", "create", "upsert_user_attn");
const _p2 = scopeBuilder.address();
// @ts-expect-error: delete is not a valid scope
const _p3 = scopeBuilder.address("delete");

export function buildRolePermissions(...permissions: TScope[] | TScope[][]) {
  return new Set(permissions.flat());
}
